import { c as _c } from "react/compiler-runtime";
import { IcoClose24, IcoPlusSmall16 } from '@onefootprint/icons';
import { Form, IconButton, LinkButton, type TemplateInputProps } from '@onefootprint/ui';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import { asOptionsControl, type CustomQuestionsFormData } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type MultipleChoiceFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const MultipleChoiceForm = t0 => {
  const $ = _c(69);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  useAutoDataIdentifier(questionIndex);
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = asOptionsControl(control);
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const optionsControl = t1;
  const t2 = `questions.${questionIndex}.options`;
  let t3;
  if ($[2] !== optionsControl || $[3] !== t2) {
    t3 = {
      control: optionsControl,
      name: t2
    };
    $[2] = optionsControl;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t3);
  let t4;
  if ($[5] !== fields.length || $[6] !== remove) {
    t4 = index => {
      if (fields.length > 2) {
        remove(index);
      }
    };
    $[5] = fields.length;
    $[6] = remove;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleRemoveOption = t4;
  const t5 = `questions.${questionIndex}.label`;
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp2);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== autocompleteItems) {
    t8 = autocompleteItems ?? {};
    $[12] = autocompleteItems;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Form.TemplateInput name={t5} label={t6} placeholder={t7} size="compact" autocompleteItems={t8} />;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp3);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <div className="text-label-2 text-primary">{t10}</div>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== fields || $[24] !== handleRemoveOption || $[25] !== questionIndex || $[26] !== t) {
    let t13;
    if ($[28] !== handleRemoveOption || $[29] !== questionIndex || $[30] !== t) {
      t13 = (field, index_0) => <div key={field.id} className="flex items-center gap-2"><Form.Input name={`questions.${questionIndex}.options.${index_0}.label`} placeholder={t(_temp4, {
          index: index_0 + 1
        })} size="compact" rules={{
          required: t(_temp5)
        }} />{index_0 > 1 && <IconButton icon={IcoClose24} onClick={() => handleRemoveOption(index_0)} aria-label={t(_temp6)} />}</div>;
      $[28] = handleRemoveOption;
      $[29] = questionIndex;
      $[30] = t;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    t12 = fields.map(t13);
    $[23] = fields;
    $[24] = handleRemoveOption;
    $[25] = questionIndex;
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[32] !== t12) {
    t13 = <div className="flex flex-col gap-2">{t12}</div>;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== append || $[35] !== fields.length) {
    t14 = () => append({
      value: `option-${fields.length + 1}`,
      label: ""
    });
    $[34] = append;
    $[35] = fields.length;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t) {
    t15 = t(_temp7);
    $[37] = t;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t14 || $[40] !== t15) {
    t16 = <div className="mt-2"><LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" variant="label-2" onClick={t14}>{t15}</LinkButton></div>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t11 || $[43] !== t13 || $[44] !== t16) {
    t17 = <div className="flex flex-col gap-2">{t11}{t13}{t16}</div>;
    $[42] = t11;
    $[43] = t13;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t) {
    t18 = t(_temp8);
    $[46] = t;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t) {
    t19 = t(_temp9);
    $[48] = t;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t) {
    t20 = t(_temp10);
    $[50] = t;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t20) {
    t21 = {
      text: t20
    };
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== questionIndex || $[55] !== t18 || $[56] !== t19 || $[57] !== t21) {
    t22 = <DataIdentifierField questionIndex={questionIndex} label={t18} placeholder={t19} tooltip={t21} />;
    $[54] = questionIndex;
    $[55] = t18;
    $[56] = t19;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  const t23 = `questions.${questionIndex}.required`;
  let t24;
  if ($[59] !== t) {
    t24 = t(_temp11);
    $[59] = t;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t23 || $[62] !== t24) {
    t25 = <Form.Toggle name={t23} label={t24} size="compact" />;
    $[61] = t23;
    $[62] = t24;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t17 || $[65] !== t22 || $[66] !== t25 || $[67] !== t9) {
    t26 = <div className="flex flex-col gap-6">{t9}{t17}{t22}{t25}</div>;
    $[64] = t17;
    $[65] = t22;
    $[66] = t25;
    $[67] = t9;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  return t26;
};
export default MultipleChoiceForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.options;
}
function _temp4($_2) {
  return $_2.form.optionPlaceholder;
}
function _temp5($_3) {
  return $_3.form.optionRequired;
}
function _temp6($_4) {
  return $_4.form.removeOption;
}
function _temp7($_5) {
  return $_5.form.addOption;
}
function _temp8($_6) {
  return $_6.form.dataIdentifier;
}
function _temp9($_7) {
  return $_7.form.dataIdentifierPlaceholder;
}
function _temp10($_8) {
  return $_8.form.dataIdentifierTooltip;
}
function _temp11($_9) {
  return $_9.form.required;
}